import React, { Component, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import FormFiltersIpAccess from '../components/formFiltersIpAccess';

import SelectorCopy from '../../common/selectorCopy';
import Loading from '../../common/loading';
import CSVExport from '../../common/csvExport';

import './style.scss';
import { controlRole } from '../../common/actions/controlRole';
import { isEmpty, isNil, withNavigate } from '../../utility';
import expanableComponentLoginInfo from '../components/expanableComponentIpAccess';

class IpAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingForRole: true,
            isLoading: false,

            openFilters: true,
            openFiltersDesktop: false,

            // informazioni che dovranno andare nel CSV da esportare
            headersCSV: [],
            dataCSV: [],

            type: '',
            modal: false
        }

        this.setLoading = this.setLoading.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }


    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare le info per ip, viene rispedito alla home
        if (!isEmpty(this.props.role.player)) {
            if (!controlRole(this.props.role.player, "api/Player/LoginsInfoByIp", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare gli ip!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare le info per ip, viene rispedito alla home
        if (!isEmpty(this.props.role.player)) {
            if (!controlRole(this.props.role.player, "api/Player/LoginsInfoByIp", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare gli ip!')

            } else
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    setLoading = (value) => {
        this.setState({ isLoading: value });
    }

    toggleModal = () => {
        this.setState({
            modal: false,
            titleModal: '',
            type: ''
        });
    }

    render() {
        const { player, role } = this.props;

        const columns = [
            {
                name: 'Indirizzo Ip',
                selector: row => <SelectorCopy item={row.deviceIp} infoNotify={this.props.infoNotify} />,
            }
        ];

        const customStyles = {
            rows: {
                style: {
                    minHeight: '50px',
                }
            },
            headCells: {
                style: {
                    paddingLeft: '8px',
                    fontWeight: 600,
                },
            },
            headRow: {
                style: {
                    minHeight: '35px',
                },
            },
            cells: {
                style: {
                    paddingLeft: '8px',
                },
            },
        };

        return (
            <Fragment>
                {
                    this.state.loadingForRole ? <Loading /> :
                        <Fragment>
                            <div className="row">
                                <div className="col-12 licenceDesktop">
                                    <div className="contentFilterSearch">
                                        <FormFiltersIpAccess
                                            player={player}
                                            role={role}

                                            getLoginInfo={this.props.getLoginInfoIp}

                                            warningNotify={this.props.warningNotify}
                                            infoNotify={this.props.infoNotify}
                                            errorNotify={this.props.errorNotify}
                                            successNotify={this.props.successNotify}
                                        />
                                    </div>

                                    <div className="contentUser">
                                        <div className="row titleMobile">
                                            <div className="col-6">
                                                <h2 className='inlineBlock'>Accessi per Ip</h2>
                                            </div>

                                            {
                                                !isNil(player.listLoginInfoIp) &&
                                                <div className="col-6 text-end">
                                                    <CSVExport
                                                        data={player.listLoginInfoIp}
                                                        filename="list-licences.csv"
                                                        label="Scarica la lista delle playlist selezionate"
                                                    />
                                                </div>
                                            }
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <hr />
                                                <DataTable
                                                    columns={columns}
                                                    data={player.listLoginInfoIp}
                                                    customStyles={customStyles}
                                                    noHeader
                                                    striped
                                                    highlightOnHover
                                                    pointerOnHover
                                                    clearSelectedRows
                                                    expandableRows={player.isLoading ? false : true}
                                                    expandOnRowClicked
                                                    expandableRowsComponent={expanableComponentLoginInfo}
                                                    expandableRowsComponentProps={{
                                                        "getLoginInfo": this.props.getLoginInfoIp,
                                                        "setIdPlayerForDetail": this.props.setIdPlayerForDetail,
                                                        "handleNavigation": this.props.handleNavigation,
                                                        "errorNotify": this.props.errorNotify,
                                                        "successNotify": this.props.successNotify,
                                                        "infoNotify": this.props.infoNotify
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {(player.isLoading || player.isLoadingChange || this.state.isLoading) && <Loading />}
                                </div>
                            </div>
                        </Fragment>
                }

            </Fragment>
        )
    }
}

export default withNavigate(IpAccess);